import React, { useStat, useEffect, useRef, useState } from 'react';
import { connect, useSelector, useDispatch} from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import "../../../../../../../css/workspace.css";
import $ from "jquery";
import {
    Tooltip,
    Input,
  } from "antd";
import {
  DeleteTwoTone,
  CheckCircleOutlined
} from "@ant-design/icons";
import {
    deleteDocumentV2,
    getWalkthroughs
  } from "../../../../../../../redux/actions/collectionsV2";
import fileIcon from "../../../../../../../images/collection-icons/file-text-big.svg";
import { notify } from "../../../../../../../components/Snack";

const UploadedDocs = () => {

    const dispatch = useDispatch();
    const queryParams = useLocation().search;
    const collectionName =  new URLSearchParams(queryParams).get("name");

    const groupPlan = useSelector((state) => state.userReducer.groupPlan);
    let planType;
    if (groupPlan?.planId == 4) {
        planType = "team";
    } else if (groupPlan?.planId == 5) {
        planType = "business";
    } else {
        planType = "pro";
    }

    const [docsList, setDocsList] = useState([]);
    const [docSelected, setDocSelected] = useState("");
    const [docListTemp, setDocListTemp] = useState([]);

    const userDetails = useSelector(
        (state) => state.organizationReducer.currentOrganization
    );

    const documentsList = useSelector((state) => state.collectionReducer.collectionDocs);


    useEffect(() => {
      let files = [];
      documentsList?.map((obj, ind) => {
        files?.push(obj?.document_name)
      })
      setDocsList(files);
      setDocListTemp(files);
    },[documentsList]);

    const onSearch = async (value) => {
        const filteredDocList = docListTemp.filter((s) =>
              s.toLowerCase().match(value.toLowerCase())
            );
        setDocsList(filteredDocList);
    };

    const deleteDoc = async (obj) => {
        const uploadDocumentResponse = await deleteDocumentV2(collectionName, obj, planType);
       
        if (uploadDocumentResponse?.status == "OK") {
            
            const index = docsList.indexOf(obj);
            if (index > -1) {
                setDocsList((prevItems) => [
                    ...prevItems.slice(0, index),  
                    ...prevItems.slice(index + 1)
                ]);
            }
            dispatch(notify("success", "Document is removed"));
            dispatch(getWalkthroughs(collectionName));
        } else {
            dispatch(notify("error", "Document removal failed"));
        }
    };

    return (
        <>
          <div className="csd-search-bar">
            <Input
              placeholder="Search Document"
              onChange={(e) => onSearch(e.target.value)}
            />
          </div>
          <div className="resource-list" style={{overflowY: "auto"}}>
          {docsList?.length > 0
            ? docsList.map((obj, ind) => {
                if (obj?.length > 0) {
                  return (
                    <div
                      className="tl-block"
                      onClick={(e) => {
                        // if (obj?.status == "success") {
                          setDocSelected(obj);
                          if ($(".tl-block").hasClass("active")) {
                            $(e.target).removeClass("active");
                            $(e.target?.parentNode?.parentNode).removeClass(
                              "active"
                            );
                          } else {
                            $(e.target).addClass("active");
                            $(e.target?.parentNode?.parentNode).addClass(
                              "active"
                            );
                          }
  
                          if ($(".tl-block").hasClass("active")) {
                            $(".tl-block").removeClass("active");
                            $(e.target).addClass("active");
                            $(e.target?.parentNode?.parentNode).addClass(
                              "active"
                            );
                          }
                        //}
                      }}
                    >
                      {obj?.status != "inprogress" ? (
                        <>
                          <div
                            data-toggle="modal"
                            data-target="#documentDeleteModal"
                          >
                            <CheckCircleOutlined style={{ color: "#fff" }} />
                            {userDetails?.role_id == "2" ? (
                              <>
                                <Tooltip
                                  title="Delete File"
                                  onClick={() => {
                                    deleteDoc(obj);
                                  }}
                                >
                                  <DeleteTwoTone
                                    className="csd-delete-file"
                                    twoToneColor="#fd2000"
                                  />
                                </Tooltip>
                              </>
                            ) : null}
                          </div>
                        </>
                      ) : null}
  
                      <div className="tl-icon">
                        <div className="cts-avatar" style={{backgroundColor: '#4B9EFF'}}>
                          <img src={fileIcon} alt="" />
                        </div>
                      </div>
  
                      <div className="tl-cont">
                        <p title={obj}>
                          {obj?.length > 50
                            ? `${obj?.substring(0, 50)}...`
                            : obj}
                        </p>
                      </div>
                    </div>
                  );
                }
              })
            : null}
            </div>
        </>
    );

}
export default UploadedDocs;